<template>
	<div id="cMain">
		<div class="cafe_newbody">
			<popular-list></popular-list>
			<div id="mAside">
				<cafe-notice></cafe-notice>
				<cafe-support></cafe-support>

				<div class="cafe_issue">
					<div class="wrap_tit">
						<h3 class="tit_item">실시간 이슈</h3>
						<ul class="tab_issue" id="tab_keyword" role="tablist">
							<li role="presentation" class="on">
								<a href="#none" class="link_tab realtime" role="tab" aria-controls="keywordList" aria-selected="true">전체</a>
							</li>
							<li role="presentation">
								<a href="#none" class="link_tab sisa" role="tab" aria-controls="keywordList" aria-selected="false">뉴스</a>
							</li>
							<li role="presentation">
								<a href="#none" class="link_tab entertain" role="tab" aria-controls="keywordList" aria-selected="false">연예</a>
							</li>
							<li role="presentation">
								<a href="#none" class="link_tab sports" role="tab" aria-controls="keywordList" aria-selected="false">스포츠</a>
							</li>
						</ul>
					</div>
					<ol class="list_issue" id="keywordList" role="tabpanel"></ol>
				</div>
			</div>
		</div>
		<div v-tiara="tiaraObj.banner" v-if="hotIssueBanner && hotIssueBanner.image" class="hot_issue_banner">
			<a :href="hotIssueBanner.link" target="_blank">
				<!-- TODO -->
				<!--<img :src="hotIssueBanner.image" :alt="hotIssueBanner.content" width="1100">-->
				<img :src="hotIssueBanner.image" alt="인기글 하단 배너" width="1100">
			</a>
		</div>
		<cafe-fancafe></cafe-fancafe>
		<cafe-category></cafe-category>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import $ from 'jquery';

	import PopularList from './PopularList.vue'
	import CafeNotice from './CafeNotice.vue'
	import CafeSupport from './CafeSupport.vue'
	import CafeFancafe from './CafeFancafe.vue'
	import CafeCategory from './CafeCategory.vue'

	export default {
		components: {
			PopularList,
			CafeNotice,
			CafeSupport,
			CafeFancafe,
			CafeCategory,
		},
		computed: {
			...mapGetters({
				hotIssueBanner: 'getHotIssueBanner',
				tiaraObj: 'getTiaraObj',
			}),
		},
		async created(){
			await this.$store.dispatch('loadHotIssueBanner');

			$('#keywordList').on('click', () => {
				this.$trackEvent(this.tiaraObj.hotIssue);
			});
		}
	}
</script>
